import { render, staticRenderFns } from "./FormTreatment.vue?vue&type=template&id=4cd3bab8"
import script from "./FormTreatment.vue?vue&type=script&lang=js"
export * from "./FormTreatment.vue?vue&type=script&lang=js"
import style0 from "./FormTreatment.vue?vue&type=style&index=0&id=4cd3bab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports